import styled from 'styled-components';

export const AppWrapper = styled.div`
  display: flex;
  height: 100%;
  background: var(--surface-default);
  color: var(--text-default);
`;
